import { Component, EventEmitter, OnInit, Output, ViewChild, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { NotaFiscalServicoModel } from '../../models/notaFiscalServico.model';
import { Icones } from '../../shared/variaveisDeRotas';
import { AccordionModule } from 'primeng/accordion';
import { faq, listaFaq } from '../../shared/mock/accordionTab';
import { listaTutorial, tutorial } from '../../shared/mock/tutorial';
import { listaDescricao, descricao, retornaDescricao } from '../../shared/mock/descricao';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { CommonModule } from '@angular/common';
import { KpiCardComponent } from './components/kpi-card.component';
import { DashboardChartComponent } from './components/dashboard-chart.component';
import { PendenciasListComponent, Pendencia } from './components/pendencias-list.component';
import { TutorialFaqComponent } from './components/tutorial-faq.component';
import { DashboardService } from './dashboard.service';
import { Observable, forkJoin, of, map, shareReplay, BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { DashboardCalendarComponent } from './components/dashboard-calendar.component';
import { LoginHelper } from '../../helpers/login.helper';
import { JwtHelper } from '../../helpers/jwtDecode.helper';
import { SpinnerService } from '../../services/spinner.service';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports:
    [ChartModule,
      AccordionModule,
      TooltipModule,
      DividerModule,
      CardModule,
      ChipModule,
      CommonModule,
      KpiCardComponent,
      DashboardChartComponent,
      PendenciasListComponent,
      TutorialFaqComponent,
      DashboardCalendarComponent,
      SpinnerServiceComponent,
    ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class HomeComponent implements OnInit, OnDestroy {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  notaFiscalServicoArray: NotaFiscalServicoModel[] = [];

  nfse: any;
  options: any;
  seta: string = Icones.seta;
  retirarTutorial: boolean = false;

  kpis$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  chartData$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  pendencias$: Observable<Pendencia[]>;
  receitasPorCliente$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private destroy$ = new Subject<void>();
  constructor(
    private dashboardService: DashboardService,
    private loginHelper: LoginHelper,
    private jwtHelper: JwtHelper,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.tituloChange.emit('Página Inicial');
    this.iconeChange.emit(Icones.casaAmarelo);
    this.spinnerService.show('Carregando dashboard...');
    const userData = this.loginHelper.get();
    const observablesToWait: Observable<any>[] = [];
    
    if (userData && userData.token) {
      const usuarioId = this.jwtHelper.getUserIdFromToken();
      
      if (usuarioId) {
        const dashboardDataObs = this.dashboardService.getAllDashboardData(usuarioId).pipe(
          shareReplay(1),
          takeUntil(this.destroy$)
        );

        dashboardDataObs.subscribe(data => {
          this.kpis$.next(data.kpis);
          this.chartData$.next(data.chartData);
          this.receitasPorCliente$.next(data.receitasPorCliente);
        });
        
        observablesToWait.push(dashboardDataObs);
      } else {
        console.warn('⚠️ Não foi possível obter o userId do token, usando fallback');
  
        const dashboardDataObs = this.dashboardService.getAllDashboardData('mock-user').pipe(
          shareReplay(1),
          takeUntil(this.destroy$)
        );
        
        dashboardDataObs.subscribe(data => {
          this.kpis$.next(data.kpis);
          this.chartData$.next(data.chartData);
          this.receitasPorCliente$.next(data.receitasPorCliente);
        });
 
        observablesToWait.push(dashboardDataObs);
      }
    } else {
      console.warn('⚠️ Usuário não logado, usando dados mock');
      
      const dashboardDataObs = this.dashboardService.getAllDashboardData('mock-user').pipe(
        shareReplay(1),
        takeUntil(this.destroy$)
      );
      
      dashboardDataObs.subscribe(data => {
        this.kpis$.next(data.kpis);
        this.chartData$.next(data.chartData);
        this.receitasPorCliente$.next(data.receitasPorCliente);
      });
 
      observablesToWait.push(dashboardDataObs);
    }

    const pendenciasObs = this.dashboardService.getPendencias().pipe(
      takeUntil(this.destroy$)
    );
    this.pendencias$ = pendenciasObs;
    observablesToWait.push(pendenciasObs);

    forkJoin(observablesToWait)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results) => {
          this.spinnerService.hide();
        },
        error: (error) => {
          this.spinnerService.hide();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  buscarFaqPorTitulo(tema: string): faq | undefined {
    return listaFaq.find(faq => faq.tema === tema);
  }

  buscarTutorialPorTitulo(tema: string): tutorial | undefined {
    return listaTutorial.find(tutorial => tutorial.tema === tema);
  }

  parseDateFromMonthYear(dateString: string): Date {
    const [month, year] = dateString.split('/').map(part => parseInt(part, 10));
    return new Date(year, month - 1);
  }

  alterarStatusTutorial() {
    this.retirarTutorial = !this.retirarTutorial
  }
}
